export class SlickGridProperties {
    constructor(public id: string, public width: number, public disabled: boolean) {
        if (!width) this.width = 80;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/models/slick-grid-properties.ts